// TODO: I have invested a lot of time to refactor Plans, adding another component will be a lot of work. I will skip this for now. but sure we need to refactor Chip Mui to Badge
import { ChipProps } from '@mui/material/Chip';

import StyledBadge from '@webclient/components/upgrade-modal/components/card/key-features/badge/styles';

import SmartStarAltRounded from '~icons/knowz-iconify/smart-star-alt-rounded';

type Props = ChipProps;

export default function Badge({ label }: Props) {
  return (
    <StyledBadge
      label={label}
      icon={<SmartStarAltRounded />}
    />
  );
}
